import { createRescueOrder } from '../js/request';
import { ACTION_NAME, INIT_STATE } from '../js/constant';

export const createOrderAction = options => {
  return {
    type: ACTION_NAME.CREATE_RESCUE_ORDER,
    payload: createRescueOrder(options)
  }
}

export const setUserInfoAction = value => {
  return {
    type: ACTION_NAME.SET_USER_INFO_DATA,
    payload: value
  };
}

export const setPageConfigAction = value => {
  return {
    type: ACTION_NAME.SET_PAGE_CONFIG_DATA,
    payload: value
  };
}

export const setUploadedImagesData = value => {
  return {
    type: ACTION_NAME.SET_UPLOAD_IMGS_DATA,
    payload: value
  }
}

export const resetFormData = () => {
  return {
    type: ACTION_NAME.RESET_FORM_DATA,
    payload: INIT_STATE
  }
}
